// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"d9e8285c","290":"388f0ebd","358":"cd4117df","428":"b943664a","672":"f16f4a5f"}[chunkId] + ".chunk.js";
};